'use client';

import dynamic from 'next/dynamic';
import { Suspense } from 'react';
import JsonLd from '@/components/ui/JsonLd';
import { generateLocalBusinessSchema, generateOrganizationSchema, generateWebSiteSchema } from '@/lib/schema';
import HeroSection from '@/components/sections/HeroSection';
import FeaturedProducts from '@/components/sections/FeaturedProducts';
import Testimonials from '@/components/sections/Testimonials';
import WhyUs from '@/components/sections/WhyUs';
import Contact from '@/components/sections/Contact';
import SalonGallery from '@/components/sections/SalonGallery';
import ProjectShowcase from '@/components/sections/ProjectShowcase';

import FeaturedCategories from '@/components/sections/FeaturedCategories';
// Not: Next.js metadata'yı server componentlerde destekler, bu istemci bileşeni olduğu için
// metadata'lar layout.tsx içinde tanımlanacak

export default function Home() {
  // JSON-LD şemalarını oluşturuyoruz
  const localBusinessSchema = generateLocalBusinessSchema();
  const organizationSchema = generateOrganizationSchema();
  const webSiteSchema = generateWebSiteSchema();
  
  return (
    <div className="overflow-x-hidden">
      {/* JSON-LD Şemaları */}
      <JsonLd schema={localBusinessSchema} />
      <JsonLd schema={organizationSchema} />
      <JsonLd schema={webSiteSchema} />
      
      {/* Ana Slider */}
      <HeroSection />
      
      {/* Proje Görsel Galerisi */}
      <ProjectShowcase className="m-0" id="project-showcase" />
      
      {/* Kategoriler */}
      <FeaturedCategories />
      
      {/* Ürünler */}
      <Suspense fallback={<div className="h-[400px] bg-gray-100 animate-pulse rounded-lg mt-12"></div>}>
        <FeaturedProducts />
      </Suspense>
      
      {/* Örnek Salonlar Galerisi */}
      <SalonGallery />
      
      <WhyUs />
      <Contact />
    </div>
  );
}
